import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M14.066 4.351a1.2 1.2 0 0 1 1.697 0l3.885 3.886a1.2 1.2 0 0 1 0 1.697L9.934 19.65a1.2 1.2 0 0 1-.848.351H5.2A1.2 1.2 0 0 1 4 18.8v-3.886a1.2 1.2 0 0 1 .351-.848zm.848.849L18.8 9.086 9.086 18.8H5.2v-3.886z",
      "clip-rule": "evenodd"
    }, null, -1)
  ])))
}
export default { render: render }